











































import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import Vue from 'vue'
import RespondecoStepper from '@/shared/components/respondeco-stepper.vue'
import RespondecoStep from '@/shared/components/respondeco-step.vue'
import NewProjectBasics from '@/business/project/components/new-project/new-project-basics.vue'
import NewProjectDescription from '@/business/project/components/new-project/new-project-description.vue'
import { TypedForm } from '@/shared/forms/typed-form'
import {
  NewProjectForm,
  newProjectFormMapping,
} from '@/business/project/components/new-project/new-project-form'
import { ProjectResponse } from '@/api/generated'
import { CREATE_PROJECT, FETCH_PROJECT } from '@/business/project/store/types'
import { ProjectViewModel } from '@/business/project/interfaces/project-view-model'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { Injector } from '@/config/dependency-injection'
import { ProjectModule } from '@/business/project/store/project-module'
import { NotificationService } from '@/shared/services/notification-service'
import { VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import RespondecoTypedForm from '@/shared/components/respondeco-typed-form.vue'
import { loggerFor } from '@/shared/utils/logger'
import { projectRequestResponseMapping } from '@/business/project/models/project-request-response-mapping'
import RespondecoFormGroup from '@/shared/components/respondeco-form-group.vue'
import RespondecoResourceGallery from '@/shared/components/respondeco-resource-gallery.vue'

@Component({
  name: 'new-project',
  components: {
    RespondecoResourceGallery,
    RespondecoFormGroup,
    RespondecoTypedForm,
    NewProjectDescription,
    NewProjectBasics,
    RespondecoStep,
    RespondecoStepper,
  },
})
export default class NewProject extends Vue implements Hooks {
  public activeStep = 1

  public form!: TypedForm<ProjectResponse, NewProjectForm>

  private loaderHelper = Injector.get(LoaderHelper)
  private notificationService = Injector.get(NotificationService)
  private projectModule = Injector.get(ProjectModule)
  private router = Injector.get<VueRouter>(RouterToken)

  private projectRequestResponseMapping = projectRequestResponseMapping()

  private logger = loggerFor('New Project')

  get loading() {
    return this.loaderHelper.isLoading(FETCH_PROJECT)
  }

  get project(): ProjectViewModel {
    return this.viewModel.project
  }

  get saving() {
    return this.loaderHelper.isLoading(CREATE_PROJECT)
  }

  get viewModel() {
    return this.projectModule.data
  }

  public data() {
    return {
      form: new TypedForm(newProjectFormMapping(), this),
    }
  }

  public stepChanged(step: number): void {
    this.activeStep = step + 1

    this.logger.info(this.form.serialize())
  }

  public submit(): void {
    const model: ProjectResponse = {
      ...this.form.serialize(),
      visible: false,
    }

    this.projectModule
      .createProject({
        projectRequest: this.projectRequestResponseMapping.deserialize(model),
      })
      .then((project: ProjectResponse) => {
        this.notificationService.success('common.successfulSave')

        this.router.replace({
          name: 'project-settings',
          params: {
            id: String(project.id),
          },
        })
      })
      .catch(
        this.notificationService.errorHandler({
          409: 'project.failure_code.409',
        })
      )
  }

  public validations() {
    return this.form.validations()
  }
}
